'use strict'

exports = module.exports = require('./commonjs/RelativeTimeFormat.js').default
exports['default'] = require('./commonjs/RelativeTimeFormat.js').default